/**
 * API Pagination page — cursor-based pagination for list endpoints.
 */

import { createFileRoute } from "@tanstack/react-router";
import { DocsPage } from "@/components/docs/docs-page";
import { apiPaginationContent } from "@/constants/docs/api-pagination";

export const Route = createFileRoute("/docs/api-pagination")({
	component: ApiPaginationPage,
});

function ApiPaginationPage() {
	return <DocsPage title="Pagination" content={apiPaginationContent} />;
}
